var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrgChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1353,
    height: 703,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(144 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 270.678 0.84231",
    stroke: "#D0CECE",
    strokeWidth: 3,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 140.5 648.342)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.5 493.5 284.5 648.044",
    stroke: "#D0CECE",
    strokeWidth: 3,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.5 291.5 284.928 398.53",
    stroke: "#D0CECE",
    strokeWidth: 3,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.5 149.5 284.5 197.014",
    stroke: "#D0CECE",
    strokeWidth: 3,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.5 491.5 1065.5 596.195",
    stroke: "#D0CECE",
    strokeWidth: 3,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.000419947 104.072",
    stroke: "#D0CECE",
    strokeWidth: 3,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 1065.5 292.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.5 149.5 1065.5 197.951",
    stroke: "#D0CECE",
    strokeWidth: 3,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533 14.8335C533 6.08892 540.089-1 548.833-1L799.167-1C807.911-1 815 6.08892 815 14.8335L815 78.1665C815 86.9111 807.911 94 799.167 94L548.833 94C540.089 94 533 86.9111 533 78.1665Z",
    stroke: "#D0CECE",
    strokeWidth: 6,
    strokeMiterlimit: 8,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 21,
    transform: "translate(596.28 41)"
  }, "Expert Comptable"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 21,
    transform: "translate(624.134 67)"
  }, "Yann CADIC"), /*#__PURE__*/React.createElement("path", {
    d: "M143 212.667C143 204.014 150.014 197 158.667 197L408.333 197C416.986 197 424 204.014 424 212.667L424 275.333C424 283.986 416.986 291 408.333 291L158.667 291C150.014 291 143 283.986 143 275.333Z",
    stroke: "#2F5597",
    strokeWidth: 6,
    strokeMiterlimit: 8,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 21,
    transform: "translate(215.362 251)"
  }, "P\xF4le Comptable"), /*#__PURE__*/React.createElement("path", {
    d: "M144 413.834C144 405.089 151.089 398 159.834 398L409.166 398C417.911 398 425 405.089 425 413.834L425 477.166C425 485.911 417.911 493 409.166 493L159.834 493C151.089 493 144 485.911 144 477.166Z",
    stroke: "#2F5597",
    strokeWidth: 6,
    strokeMiterlimit: 8,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 21,
    transform: "translate(195.646 453)"
  }, "Comptable confirm\xE9"), /*#__PURE__*/React.createElement("path", {
    d: "M-141 616.667C-141 608.014-133.986 601-125.333 601L124.333 601C132.986 601 140 608.014 140 616.667L140 679.333C140 687.986 132.986 695 124.333 695L-125.333 695C-133.986 695-141 687.986-141 679.333Z",
    stroke: "#2F5597",
    strokeWidth: 6,
    strokeMiterlimit: 8,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 21,
    transform: "translate(-104.599 643)"
  }, "Alternant(e) assistant(e)"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 21,
    transform: "translate(-98.6727 669)"
  }, "comptable et juridique"), /*#__PURE__*/React.createElement("path", {
    d: "M411 615.834C411 607.089 418.089 600 426.834 600L676.166 600C684.911 600 692 607.089 692 615.834L692 679.166C692 687.911 684.911 695 676.166 695L426.834 695C418.089 695 411 687.911 411 679.166Z",
    stroke: "#2F5597",
    strokeWidth: 6,
    strokeMiterlimit: 8,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 21,
    transform: "translate(447.186 642)"
  }, "Alternant(e) assistant(e)"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 21,
    transform: "translate(445.786 668)"
  }, "comptable et secr\xE9tariat"), /*#__PURE__*/React.createElement("path", {
    d: "M924 212.834C924 204.089 931.089 197 939.834 197L1189.17 197C1197.91 197 1205 204.089 1205 212.834L1205 276.166C1205 284.911 1197.91 292 1189.17 292L939.834 292C931.089 292 924 284.911 924 276.166Z",
    stroke: "#FF0000",
    strokeWidth: 6,
    strokeMiterlimit: 8,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 21,
    transform: "translate(1018.51 252)"
  }, "P\xF4le Social"), /*#__PURE__*/React.createElement("path", {
    d: "M924 411.834C924 403.089 931.089 396 939.834 396L1189.17 396C1197.91 396 1205 403.089 1205 411.834L1205 475.166C1205 483.911 1197.91 491 1189.17 491L939.834 491C931.089 491 924 483.911 924 475.166Z",
    stroke: "#FF0000",
    strokeWidth: 6,
    strokeMiterlimit: 8,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 21,
    transform: "translate(945.036 438)"
  }, "Gestionnaire paye confirm\xE9"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 21,
    transform: "translate(1007.2 464)"
  }, "et secr\xE9tariat"), /*#__PURE__*/React.createElement("path", {
    d: "M924 611.667C924 603.014 931.014 596 939.667 596L1189.33 596C1197.99 596 1205 603.014 1205 611.667L1205 674.333C1205 682.986 1197.99 690 1189.33 690L939.667 690C931.014 690 924 682.986 924 674.333Z",
    stroke: "#FF0000",
    strokeWidth: 6,
    strokeMiterlimit: 8,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 21,
    transform: "translate(955.982 650)"
  }, "Alternant(e) Bureautique"), /*#__PURE__*/React.createElement("path", {
    d: "M674.5 94.5001 674.5 152.258",
    stroke: "#D0CECE",
    strokeWidth: 3,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.5 149.5 1066.48 149.5",
    stroke: "#D0CECE",
    strokeWidth: 3,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgChart);
export default __webpack_public_path__ + "static/media/orgChart.fa2cbfdabfc590ef3def9bb0403724c4.svg";
export { ForwardRef as ReactComponent };